import {NullableUndefinedNumber} from "../../../../common/types/nullable-types";
import {IGeoComplyError} from "./geo-location.strategy.interface";

export const GENERIC_GEO_ERROR_CODE = -1;
export enum GeoComplyFailureReason {
    TechnicalProblem = 4,
    GeoComplyTimeout = 5
}

export enum GeoComplyErrorCodes {
    UnknownError = 600,
    NetworkConnectionIsNotAvailable = 602,
    GeoComplyServerIsUnreachable = 603,
    LicenceIsExpired = 608,
    PluginNotInstalled = 612,
    CommunicationWitGCLocationServiceFailed = 613,
    PluginNotUpdated = 615,
}

export function isGeoComplyPluginInstallationRequired(errorCode: NullableUndefinedNumber) {
    return errorCode === GeoComplyErrorCodes.PluginNotInstalled
            || errorCode === GeoComplyErrorCodes.PluginNotUpdated;
}

const RETRYABLE_GEO_COMPLY_ERRORS: GeoComplyErrorCodes[] = [
    GeoComplyErrorCodes.NetworkConnectionIsNotAvailable,
    GeoComplyErrorCodes.GeoComplyServerIsUnreachable,
    GeoComplyErrorCodes.CommunicationWitGCLocationServiceFailed
];

export function isRetryableGeoComplyError(error: IGeoComplyError): boolean {
    return RETRYABLE_GEO_COMPLY_ERRORS.includes(error?.errorCode);

}